import React from 'react';
import ButtonBasic from 'components/Button/ButtonBasic/ButtonBasic';
import Icon from 'components/Icon/Icon';
import classes from './ButtonPrimaryNew.module.css';

interface ButtonPrimaryNewProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  contracted?: boolean;
  disabled?: boolean;
  inverted?: boolean;
  radio?: boolean;
  rounded?: boolean;
  secondary?: boolean;
  selected?: boolean;
  small?: boolean;
}

function ButtonPrimaryNew({
  onClick,
  children,
  isLoading = false,
  disabled = false,
  contracted = false,
  inverted = false,
  radio = false,
  rounded = false,
  secondary = false,
  selected = false,
  small = false,
  ...rest
}: ButtonPrimaryNewProps): React.ReactElement {
  const classNames: string[] = [classes.buttonPrimary];

  if (isLoading) classNames.push(classes.loading);
  if (contracted) classNames.push(classes.contracted);
  if (inverted) classNames.push(classes.inverted);
  if (rounded) classNames.push(classes.rounded);
  if (secondary) classNames.push(classes.secondaryColor);
  if (selected) classNames.push(classes.selected);
  if (small) classNames.push(classes.small);
  if (radio) classNames.push(classes.radio);

  return (
    <ButtonBasic
      {...rest}
      onClick={onClick}
      className={classNames.join(' ')}
      disabled={disabled || selected}
    >
      {children}
      {isLoading && (
        <div className={classes.loadingIconWrapper} data-testid="loading-spinner">
          <Icon iconName="animatedCircle" />
        </div>
      )}
    </ButtonBasic>
  );
}

export type { ButtonPrimaryNewProps };

export default ButtonPrimaryNew;
